import ForumLegalPublicPage from "./ForumLegalPublicPage";

const PrivacyPolicyPage = () => (
  <ForumLegalPublicPage
    settingKey="privacy_policy"
    fallbackTitle="Privacy Policy"
    errorMessage="Unable to load Privacy Policy."
  />
);

export default PrivacyPolicyPage;
